import { combineReducers } from 'redux'
import {setterReducer} from '../common/redux'
import * as t from './actionTypes'

const editorMode = (state = false, action) => state || action.type === t.ACTIVATE_EDITOR

const editorCase = (state = '', action) => {
  switch (action.type) {
    case t.ACTIVATE_EDITOR:
      return action.payload || ''
    case t.SET_EDITOR_CASE:
      return action.payload || ''
    default:
      return state
  }
}

const diagnoses = setterReducer([], t.SET_DIAGNOSES)
const cases = setterReducer([], t.SET_CASES)
const diagnosis = setterReducer([], t.SET_DIAGNOSIS)
const caseIndex = setterReducer(null, t.SET_CASE_INDEX)
const caseVisits = setterReducer([], t.SET_CASE_VISTS)
const caseVisit = setterReducer(null, t.SET_CASE_VISIT)
const vtoken = setterReducer(null, t.SET_VTOKEN)
const comments = setterReducer(null, t.SET_COMMENTS)

const initDiagRelib = {
  reliable: false,
  msg: ''
}
const diagnosisReliability = setterReducer(initDiagRelib, t.SET_DIAGNOSIS_RELIABILITY)

const editor = combineReducers({
  isActive: editorMode,
  activeCase: editorCase,
  diagnoses,
  cases,
  diagnosis,
  caseIndex,
  caseVisits,
  caseVisit,
  diagnosisReliability,
  vtoken,
  comments
})

export {editor as default}


// WEBPACK FOOTER //
// ./assets/editor/reducer.js